import script from "./FileJobElement.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileJobElement.vue?vue&type=script&setup=true&lang=ts"

import "./FileJobElement.vue?vue&type=style&index=0&id=051ae24c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-051ae24c"]])

export default __exports__